import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { IndexPage } from './IndexPage';

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/email'} element={<IndexPage />} />
      </Routes>
    </BrowserRouter>
  );
};
